export default __webpack_public_path__ + "static/media/blurred_background.a5c94b99.png";